import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModalController, PopoverController } from '@ionic/angular';
import { GlobalService } from '../../shared/services/global/global.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { VoucherService } from 'src/app/business-service/voucher/voucher.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { PdfService } from '../../shared/services/pdf.service';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { SendViaSocialMediaComponent } from '../../shared/popover/send-via-social-media/send-via-social-media.component';
import { LeadEmailInputComponent } from '../../shared/popover/lead-email-input/lead-email-input.component';
import { EmailService } from '../../shared/services/email/email.service';
import { TableColumnOptionsComponent } from '../../shared/popover/table-column-options/table-column-options.component';
import { ENTITY_NAMES, TRAVEL_SERVICES } from '../../shared/constants/api-constants';
import { WhatsappNumberInputComponent } from '../../shared/popover/whatsapp-number-input/whatsapp-number-input.component';
import { VoucherSelectionPopoverComponent } from '../voucher-selection-popover/voucher-selection-popover.component';
import { ItineraryService } from 'src/app/business-service/quote/itinerary.service';

@Component({
  selector: 'app-voucher-view-template',
  templateUrl: './voucher-view-template.component.html',
  styleUrls: ['./voucher-view-template.component.scss'],
})
export class VoucherViewTemplateComponent implements OnInit {

  voucherId: any;
  leadId: any;
  leadDetails: any;
  leadSelectedServices: any;
  quoteId: any;
  quoteTripDetails: any;
  voucherTemplateData: any;
  VoucherDataHtml: SafeHtml = "";

  voucherDetails: any;

  constructor(
    private _voucherService: VoucherService,
    private _modalController: ModalController,
    private _responseNotificationService: ResponseNotificationService,
    private _globalService: GlobalService,
    private _sanitizer: DomSanitizer,
    private _pdfService: PdfService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    private _leadService: LeadsService,
    private _popoverController: PopoverController,
    private _emailService: EmailService,
    private _itineraryService: ItineraryService
  ) { }

  ngOnInit() {
    this._voucherService.getVoucherAsTemplateHtml(this.voucherId).subscribe((data) => {
      this.voucherTemplateData = data;
      this.VoucherDataHtml = this._sanitizer.bypassSecurityTrustHtml(data);
    }, (error) => {
      this._responseNotificationService.showMessage("Something went wrong, please try again", true)
    })

    this._voucherService.getVoucher(this.voucherId).subscribe({
      next: (data) => {
        this.voucherDetails = data;
      },
      error: (error) => {
        console.error('Error fetching voucher details:', error);
        this._responseNotificationService.showMessage("Failed to fetch voucher details, please try again later!", true);
      }
    });

    this._itineraryService.getQuoteData(this.quoteId).subscribe({
      next: (data) => {
        this.quoteTripDetails = data.itineraryDetails;
      },
      error: (error) => {
        console.error('Error fetching quote trip details:', error);
        this._responseNotificationService.showMessage("Failed to fetch quote trip details, please try again later!", true);
      }
    })

    if (this.leadId) {
      this._leadService.getLead(this.leadId).subscribe((data) => {
        this.leadDetails = data;
      })
    }
  }

  closeModal() {
    this._modalController.dismiss()
  }

  async openDownloadPopover(event: any) {
    const options = [
      { value: "Download", path: "download" },
      { value: "Print", path: "print" }
    ];

    const popover = await this._popoverController.create({
      component: TableColumnOptionsComponent,
      event: event,
      cssClass: 'popup-component popup-component-md',
      componentProps: {
        optionsData: {
          options
        },
        onPathSelected: (data: any) => this.onPrintOptionSelected(data)
      }
    });
    return await popover.present();
  }

  onPrintOptionSelected(data: any) {
    switch (data.path) {
      case "download": {
        this.downloadVoucher();
        break;
      }
      case "print": {
        this.printVoucher();
        break;
      }
    }
    this._popoverController.dismiss();
  }

  // Print funtions
  printVoucher(): void {
    this._pdfService.generatePdf(this.voucherTemplateData).subscribe(
      (blob) => {
        const url = URL.createObjectURL(blob);

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;

        iframe.onload = () => {
          iframe.contentWindow?.print();
        };

        document.body.appendChild(iframe);
      },
      (error) => {
        console.error('Error generating PDF:', error);
      }
    );
  }

  async downloadVoucher(): Promise<void> {
    let tempSections: any[] = this.getAvalibleVoucherSections();

    if (tempSections.length === 1) {
      this.downloadIndividualVoucher({ sections: tempSections, selectedHotelIndexes: null });
    } else {
      const popover = await this._popoverController.create({
        component: VoucherSelectionPopoverComponent,
        cssClass: 'voucher-selection-popover',
        componentProps: {
          voucherDetails: this.voucherDetails,
          leadDetails: this.leadDetails,
          hotelsList: this.getHotelsList(),
          showIndividualHotelSelection: true,
          onActionPerformed: (data: any) => {
            if (data) {
              this.downloadIndividualVoucher(data)
            }
          }
        }
      })
      return await popover.present()
    }
  }

  getAvalibleVoucherSections(): any {
    let tempSections: any[] = [];
    if (this.voucherDetails?.showHotels && this.leadDetails?.travelServices?.includes(TRAVEL_SERVICES.HOTELS)) {
      tempSections.push("Accommodation");
    }
    if (this.voucherDetails?.showTransportation && this.leadDetails?.travelServices?.includes(TRAVEL_SERVICES.TRANSPORTATION)) {
      tempSections.push("Transportation");
    }
    if (this.voucherDetails?.showSightSeeing && this.leadDetails?.travelServices?.includes(TRAVEL_SERVICES.SIGHTSEEING)) {
      tempSections.push("RouteCraft");
    }
    return tempSections;
  }

  downloadFullVoucher(): void {
    this._pdfService.generatePdf(this.voucherTemplateData, true).subscribe(
      (blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Voucher _${this.voucherId}.pdf`;
        link.click();
        URL.revokeObjectURL(link.href);
      },
      (error) => {
        console.error('Error generating PDF:', error);
      }
    );
  }

  downloadIndividualVoucher(data: any) {
  const payload = {
    sections: data.sections,
    selectedHotelIndexes: data.selectedHotelIndexes ?? null
  };
  this._voucherService.getIndividualVoucherAsTemplateHtml(this.voucherId, payload).subscribe({
      next: (res) => {
        // After getting html of individual download, then print
        this._pdfService.generatePdf(res, true).subscribe({
          next: (blob) => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `$Voucher _${this.voucherId}.pdf`;
            link.click();
            URL.revokeObjectURL(link.href);
          }, error: (error) => {
            console.error('Error generating PDF:', error);
          }
        });
      }, error: (er) => {
        console.error(er);
        this._responseNotificationService.showMessage("Failed to fetch template, please try again later!", true);
      }
    })
  }

  editVoucher() {
    this.closeModal();
    this._modalPopupService.openVoucherForm(this.voucherId, this.leadId, this.quoteId, () => { })
  }

  async sendVoucher(event: Event) {
    const popover = await this._popoverController.create({
      component: SendViaSocialMediaComponent,
      event: event,
      cssClass: "popup-component-social-media",
      componentProps: {
        onPathSelected: (data: any) => this.onSocialMediaActionOptionSelected(data), // Ensure the function is passed correctly
      }
    })
    return await popover.present()
  }

  onSocialMediaActionOptionSelected(data: any) {
    let selectedOption = data.path;

    switch (selectedOption) {
      case 'whatsApp': {
        this.sendVoucherViaWhatsApp();
        break;
      }
      case 'email': {
        this.sendVoucherViaEmail();
        break;
      }
    }
  }

  async sendVoucherViaWhatsApp() {
    let tempSections: any[] = this.getAvalibleVoucherSections();
    if (tempSections.length === 1) {
      this.sendVoucherViaWhatsAppWithSections(tempSections);
    } else {
      const popover = await this._popoverController.create({
        component: VoucherSelectionPopoverComponent,
        cssClass: 'voucher-selection-popover',
        componentProps: {
          voucherDetails: this.voucherDetails,
          leadDetails: this.leadDetails,
          onActionPerformed: (data: any) => {
            if (data) {
              this.sendVoucherViaWhatsAppWithSections(data.sections);
            }
          }
        }
      });
      return await popover.present();
    }
  }
  async sendVoucherViaWhatsAppWithSections(sections: any) {
    console.log('sections being passed:', sections);
    const popover = await this._popoverController.create({
      component: WhatsappNumberInputComponent,
      cssClass: 'whatsapp-popover',
      componentProps: {
        leadPhone: this.leadDetails.phoneNumber,
        onActionPerformed: async (data: any) => {
          if (data) {
            let userDetails = await this._globalService.getLoggedInUserDetails();
            userDetails = userDetails.userDetail;
            let queryParam = `sections=${sections.join(',')}`
            const voucherLink = await this._globalService.getDocumentPdfLink("voucherlookup", this.voucherId, queryParam);
            console.log(voucherLink.url);
            let whatsappNumber: string = (data.whatsappNumber?.countryCode || "") + (data.whatsappNumber?.phone || "");

            // Message (use template literal for formatting)
            let message = 
`Dear ${this.leadDetails.firstName} ${this.leadDetails.lastName || ""},

We've attached your voucher generated against your confirmed quote.

Quote Reference No: ${this.quoteId}
Schedule: ${this.formatDate(this.quoteTripDetails.startDate)} to ${this.formatDate(this.quoteTripDetails.endDate)}
Destination: ${this.quoteTripDetails.destination.map((dest: any) => dest.location).join(" | ")}

View your voucher here: ${voucherLink.url}

For any questions or changes, please contact
*Email* ${userDetails.email || ""}
*Phone* ${userDetails.officePhoneNumber.countryCode || ""}${userDetails.officePhoneNumber.phone || ""}

We would be glad to help!`;

            // Encode message
            let encodedMessage = encodeURIComponent(message);
            // WhatsApp URL
            let url = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
            window.open(url, '_blank');
              // Open in new tab
            let req = {
              ids: [this.voucherId],
              actions: { status: "Sent To Client" }
            };
            this._voucherService.performBulkActions(req).subscribe({
              next: () => {
                this._responseNotificationService.showMessage("Voucher sent via WhatsApp and status updated.");
                this._reloadService.triggerVouchersReload();
              },
              error: () => {
                this._responseNotificationService.showMessage("Failed to update voucher status.", true);
              }
            });
          }
        }
      }
    });
    return await popover.present();
  }

  async sendVoucherViaEmail(): Promise<void> {
    let tempSections: any[] = this.getAvalibleVoucherSections();

    if (tempSections.length === 1) {
      this.sendVoucherViaEmailWithSections(tempSections);
    } else {
      const popover = await this._popoverController.create({
        component: VoucherSelectionPopoverComponent,
        cssClass: 'voucher-selection-popover',
        componentProps: {
          voucherDetails: this.voucherDetails,
          leadDetails: this.leadDetails,
          onActionPerformed: (data: any) => {
            if (data) {
              this.sendVoucherViaEmailWithSections(data.sections)
            }
          }
        }
      })
      return await popover.present()
    }
  }

  async sendVoucherViaEmailWithSections(sections:any) {
    const popover = await this._popoverController.create({
      component: LeadEmailInputComponent,
      cssClass: 'large-popover',
      componentProps: {
        leademail: this.leadDetails.email,
        onActionPerformed: (data: any) => {
          if (data) {
            data.sections = sections;
            this._emailService.sendVoucher(this.voucherId, data).subscribe({
              next: () => {
                this._responseNotificationService.showMessage("Voucher sent via email!");
              },
              error: (error) => {
                console.error('Error sending Voucher via email:', error);
                this._responseNotificationService.showMessage("Failed to send Voucher via email!", true);
              }
            })
          }
        }
      }
    })
    return await popover.present()
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    const daySuffix = this.getDaySuffix(day);
    return `${day}${daySuffix} ${month}, ${year}`;
  }

  getDaySuffix(day: number): string {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }
  getHotelsList(): any[] {
    const hotels: any[] = [];
    const data = this.voucherDetails?.accommodations?.[0]?.data || [];
    data.forEach((destItem: any, index: number) => {
      destItem.locations?.forEach((location: any) => {
        location.hotels?.forEach((hotel: any) => {
          hotels.push({
            index,
            hotelName: hotel.hotelName?.trim(),
            destination: destItem.destination,
            checkIn: hotel.checkIn,
            checkOut: hotel.checkOut
          });
        });
      });
    });
    return hotels;
  }

}
